import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ApiClass } from '@data/class/api-class'
import { environment } from '@env/environment'
import { OmnichannelMetricsResponse } from '@modules/private/omnichannel/data/interfaces/omnichannel-metrics.interface'

@Injectable({ providedIn: 'root' })
export class ApiOmnichannelMetricsService extends ApiClass {
  constructor() {
    super()
    this.path = 'omnichannel/metrics'
  }

  //* GET /omnichannel/metrics → { error, msg, data: { kpis, byAcquisition, byConversionStatus, arrivalsByMonth, topReferrers } }
  getMetrics(): Observable<{ error?: boolean; msg?: string; data: OmnichannelMetricsResponse }> {
    return this.http.get<{ error?: boolean; msg?: string; data: OmnichannelMetricsResponse }>(`${environment.apiUrl}${this.path}`, {})
  }
}
